import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, SwitchCompanySchema } from "schema"
import { z } from "zod"

type SwitchCompanyInput = z.infer<typeof SwitchCompanySchema>
type SwitchCompanyResponse = DataResponse<{ success: boolean }>

export const useSwitchCompanyMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: SwitchCompanyInput) => {
      const response = await axios.post<SwitchCompanyResponse>("/auth/switch-company", data)
      return response.data.data
    },
    onSuccess: () => {
      queryClient.clear()
    },
  })
}
